const CheckoutStepCalculator = {
    next: (checkoutSteps, currentStep, shouldRedirect) => {
        const indexOfCurrentStep = checkoutSteps.indexOf(currentStep);

        if (CheckoutStepCalculator.isLastStep(checkoutSteps, currentStep)) {
            return '';
        }

        if (!shouldRedirect) {
            return checkoutSteps[indexOfCurrentStep];
        }

        return checkoutSteps[indexOfCurrentStep + 1];
    },

    previous: (checkoutSteps, currentStep) => {
        if (CheckoutStepCalculator.isFirstStep(checkoutSteps, currentStep)) {
            return 'cart';
        }

        const indexOfCurrentStep = checkoutSteps.indexOf(currentStep);
        return checkoutSteps[indexOfCurrentStep - 1];
    },

    isStepEditable: (checkoutSteps, currentStep, orderState) => {
        const indexOfCurrentStep = checkoutSteps.indexOf(currentStep);
        const indexOfOrderState = checkoutSteps.indexOf(orderState);

        return (
            !CheckoutStepCalculator.isLastStep(checkoutSteps, orderState)
            && CheckoutStepCalculator.isValidStep(checkoutSteps, currentStep)
            && (currentStep === orderState || indexOfCurrentStep <= indexOfOrderState)
        );
    },

    isLastStep: (checkoutSteps, currentStep) => {
        const indexOfCurrentStep = checkoutSteps.indexOf(currentStep);

        return CheckoutStepCalculator.isValidStep(checkoutSteps, currentStep) && indexOfCurrentStep === checkoutSteps.length - 1;
    },

    isFirstStep: (checkoutSteps, currentStep) => {
        const indexOfCurrentStep = checkoutSteps.indexOf(currentStep);

        return indexOfCurrentStep === 0;
    },

    isValidStep: (checkoutSteps, currentStep) => checkoutSteps.indexOf(currentStep) !== -1,
};

export default CheckoutStepCalculator;



/** WEBPACK FOOTER **
 ** ./src/services/checkout-step-calculator.js
 **/